const locale = {
  THEME: {
    DOCUMENTATION: 'Documentation',
    CHINESE_SIMPLE: 'English',
    BANNER_TEXT: 'The availability of EnOS functions is subject to licenses and access permissions. Contact your system administrator if certain functions are not available in your environment.',
    PRIVACY_POLICY: 'Privacy Notice',
    USER_AGREEMENT: 'User Agreement',
    GLOBAL_SEARCH_PLACEHOLDER: 'Search this global'
  },
  preview: {
    BANNER_TEXT: 'The preview content is no longer updated and might contain outdated information. For the latest product information, visit the 3.1.0 Documentation.'
  }
};

export default locale;
